import "./App.css";

function HowItWorks(props) {
  return <div className="">How it works</div>;
}

export default HowItWorks;
